import {
  attributesHeadingSchema,
  attributesPageTitleSchema
} from "../../elements/headings/attributes.js";
import {
  guideHeadingHtml,
  guidePageTitleHtml,
  ScalarHeadingVue,
  ScalarPageTitleVue
} from "../../elements/headings/component.js";
import { validate } from "../../helpers/validate.js";
import { hydrate } from "./hydration.js";
const scalarHeading = {
  name: "scalar-heading",
  tagName: "scalar-heading",
  tiptapName: "custom_heading",
  attributeTransform: (_, attrs) => {
    return validate(attributesHeadingSchema, attrs);
  },
  render: async (props) => guideHeadingHtml(props)
};
const scalarPageTitle = {
  name: "scalar-page-title",
  tagName: "scalar-page-title",
  tiptapName: "custom_page_title",
  attributeTransform: (_, attrs) => {
    return validate(attributesPageTitleSchema, attrs);
  },
  render: async (props) => guidePageTitleHtml(props),
  hydrate
};
export {
  ScalarHeadingVue,
  ScalarPageTitleVue,
  scalarHeading,
  scalarPageTitle
};
//# sourceMappingURL=index.js.map
